import ActionFeedbackModal from '@/components/ActionFeedbackModal';
import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { CurrentLearningMapRequest } from '@/models/CurrentLearningMapRequest';
import { GetClassificationsData } from '@/models/GetClassificationsData';
import { ApplicationState } from '@/store';
import { getClassificationsRequest } from '@/store/classification/action';
import { getCurrentLearningMapRequest, saveCurrentLearningMapClear } from '@/store/learningMap/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CategoriesWordCloud from './CategoriesWordCloud';
import LearningMapButton from './LearningMapButton';
import LearningMapGoal from './LearningMapGoal';
import LearningMapHistoryChart from './LearningMapHistoryChart';
import LearningMapMediaTypeChart from './LearningMapMediaTypeChart';
import './style.scss';

const LearningMapPage: React.FC = () => {
    const {
        strings,
        learningMapLoading,
        organizationId,
        successOnSave,
        errorOnSave,
        classificationLoading,
        currentLearningMap,
        classificationsList,
    } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        learningMapLoading: state.learningMap.loading,
        successOnSave: state.learningMap.successOnSave,
        errorOnSave: state.learningMap.errorOnSave,
        classificationLoading: state.classifications.loading,
        organizationId: state.identity.data.user && state.identity.data.user.orgId,
        currentLearningMap: state.learningMap.data.currentLearningMap,
        classificationsList: state.classifications.data.classificationsList,
    }));

    const dispatch = useDispatch();

    const makeInitialRequests = () => {
        if (strings._LANGUAGE === 'pt') {
            if (classificationsList.length === 0)
                dispatch(
                    getClassificationsRequest({
                        organizationId,
                        applicationId: Constants.APP_ID,
                    } as GetClassificationsData),
                );
            dispatch(
                getCurrentLearningMapRequest({
                    withTotalFinishedContents: true,
                    withMediaTypeConsumption: true,
                } as CurrentLearningMapRequest),
            );
        }
    };

    useEffect(() => {
        if (successOnSave || errorOnSave) makeInitialRequests();
    }, [successOnSave, errorOnSave]);

    useEffect(() => {
        dispatch(saveCurrentLearningMapClear());
        makeInitialRequests();
    }, []);

    return (
        <div>
            <div className="learning-map-page">
                {!classificationLoading && !learningMapLoading ? <LearningMapButton /> : <Loader />}
                {currentLearningMap && (
                    <>
                        <LearningMapGoal />
                        <LearningMapHistoryChart />
                        <CategoriesWordCloud />
                        <LearningMapMediaTypeChart />
                    </>
                )}
            </div>
            <ActionFeedbackModal
                error={errorOnSave}
                errorMessage={strings.LEARNING_MAP.LEARNING_MAP_FAIL_ON_SAVE}
                loading={learningMapLoading}
                success={successOnSave}
                successMessage={strings.LEARNING_MAP.LEARNING_MAP_SUCCESS_ON_SAVE}
            />
        </div>
    );
};

export default LearningMapPage;
